/* src/app/ship/pickup-locations/pickup-locations.component.scss */
.locations-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1rem 2rem 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1215686275), 0 1px 2px rgba(0, 0, 0, 0.2392156863);
  z-index: 3;
}
.locations-header .title-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.locations-header .title-wrapper .locations-header-title {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
  padding: 0;
}
.locations-header .title-wrapper .learn-more {
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration-line: underline;
  line-height: 1.5;
  padding: 0 0.75em;
}
.maximum-coverage {
  color: #DF2901;
  font-size: 0.75rem;
  line-height: 1.5;
  padding: 0.5rem 0;
}
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 3rem;
}
ul.locations {
  margin: 0 0 10rem 0;
  padding: 0;
  counter-reset: listItem;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  max-height: 15rem;
  overflow: auto;
}
@media only screen and (min-width: calc(21.5rem + 1px)) and (max-width: 26.875rem) {
  ul.locations {
    max-height: 23rem !important;
  }
}
@media screen and (min-width: 48rem) {
  ul.locations {
    max-height: 29rem;
  }
}
@media only screen and (min-width: 26.875rem) and (max-width: 48rem) {
  ul.locations {
    max-height: 38rem;
  }
}
@media screen and (min-width: 25rem) and (max-width: 80rem) and (min-height: 25rem) and (max-height: 45rem) {
  ul.locations {
    max-height: 15.5rem !important;
  }
}
@media screen and (min-width: 25rem) and (max-width: 80rem) and (min-height: 25rem) and (max-height: 45rem) {
  ul.locations.ups {
    max-height: 9.5rem !important;
  }
}
ul.locations.readonly li.location {
  position: relative;
}
ul.locations.readonly li.location::before {
  counter-increment: listItem;
  content: counter(listItem) ". ";
  position: absolute;
  left: 0.75rem;
  top: 1rem;
}
ul.locations.readonly li.location ::ng-deep .mat-mdc-radio-button .mdc-form-field .mdc-label {
  padding-left: 2rem;
}
ul.locations.readonly li.location ::ng-deep .mat-mdc-radio-button .mdc-form-field .mdc-radio.mdc-radio--disabled {
  display: none;
}
ul.locations.readonly li.location ::ng-deep .mat-mdc-radio-button .mdc-form-field .mdc-radio.mdc-radio--disabled .mdc-radio__background .mdc-radio__outer-circle {
  background-color: #DFDBD7;
}
ul.locations li.location {
  padding: 1rem;
}
ul.locations li.location.selected {
  background-color: rgba(10, 128, 128, 0.1);
}
ul.locations li.location:not(.selected):hover {
  background-color: rgba(10, 128, 128, 0.05);
}
ul.locations li.location ::ng-deep .mat-mdc-radio-button .mdc-form-field {
  width: 100%;
}
ul.locations li.location ::ng-deep .mat-mdc-radio-button .mdc-form-field .mdc-radio {
  align-self: flex-start;
  margin-top: -2px;
}
ul.locations li.location ::ng-deep .mat-mdc-radio-button .mdc-form-field .mdc-label {
  padding-left: 1rem;
  flex: 1;
}
.pickup-location-search {
  position: sticky;
  top: 0;
  z-index: 2;
}
:host(.pickup-locations) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=pickup-locations.component.css.map */
